import { getTheme } from '@fluentui/react';

const { palette } = getTheme();

const mobileMaxWidth = 600;
const mobileDeviceQuery = `(max-width:${mobileMaxWidth}px)`;
const mobileDevice = `@media ${mobileDeviceQuery}`;

export const getStyles = () => {
  const tileContainer = {
    minHeight: '100px',
    marginBottom: '16px',
    width: '520px',
    fontSize: '14px',
    color: '#333333',
    display: 'grid',
    float: 'left',
    gridTemplateColumns: '100%',
    background: palette.white,
    'box-shadow': '0px 1.6px 3.6px rgba(0, 0, 0, 0.132)',
    'border-radius': '2px',
    [mobileDevice]: {
      width: 'auto',
    },
  };

  const wideTileContainer = {
    width: '1056px !important',
  };

  const tileSection = {
    paddingLeft: '16px',
    paddingRight: '16px',
  };

  const headerBorder = {
    borderBottom: `solid 1px ${palette.neutralLight}`,
  };

  const headerContainer = {
    gridRow: '1',
    marginTop: '9px',
    marginBottom: '9px',
    display: 'flex',
  };

  const dropdownContainer = {
    display: 'flex',
  };

  const closeButton = {
    color: palette.neutralSecondary,
    '&:hover': {
      color: palette.neutralSecondary,
      background: 'transparent',
    },
  };

  const contentContainer = {
    gridRow: '2',
    'margin-top': '16px',
    'margin-bottom': '8px',
  };

  const footerContainer = {
    gridRow: '3',
    'margin-top': '8px',
    'margin-bottom': '16px',
  };
  const footerContentContainer = {
    minHeight: '30px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    '& a': {
      paddingLeft: '20px',
      paddingRight: '20px',
      fontWeight: 600,
    },
    '& .pager-navigation': {
      marginTop: 0,
      right: 0,
      position: 'absolute',
    },
  };

  const footerButton = {
    backgroundColor: 'white',
    float: 'left',
    'font-style': 'normal',
    'font-weight': '600',
    'font-size': '14px',
    'line-height': '20px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  const headerText = {
    fontWeight: '600',
    fontStyle: 'normal',
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: '100%',
    width: 'auto',
    color: '#323130',
    marginTop: '3px',
    marginBottom: '3px',
  };

  const headerHelp = {
    flexGrow: 1,
    alignSelf: 'flex-end',
  };

  const smallHeaderText = {
    fontSize: '18px',
    'line-height': '24px',
    whiteSpace: 'nowrap',
    [mobileDevice]: {
      whiteSpace: 'initial',
    },
  };

  const largeHeaderText = {
    fontSize: '28px',
  };

  return {
    tileSection,
    headerBorder,
    headerContainer,
    headerText,
    headerHelp,
    smallHeaderText,
    largeHeaderText,
    dropdownContainer,
    closeButton,
    contentContainer,
    tileContainer,
    wideTileContainer,
    footerContainer,
    footerContentContainer,
    footerButton,
  };
};

export const tileStyles = {
  shimmerItem: { root: { marginBottom: '16px' } },
};

